import { FC } from 'react';
import {
  Badge,
  Flex,
  Icon,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { isEmpty } from 'ramda';
import { Link } from 'react-router-dom';
import { ProblemFilesFragment } from '../../graphql/generated';
import { EmptyState } from '../../ui/errors/empty-state';
import { format } from '../../utils/date/date';
import { formatFileSize } from '../../utils/file/file';
import { generateFileLink } from '../file-browser/name';
import { getContentTypeIcon } from '../file-browser/name';

export type ProblematicFilesResultsListProps = {
  files: ProblemFilesFragment[] | undefined;
  problemType: string;
  count: number;
};

export const ProblematicFilesResultsList: FC<ProblematicFilesResultsListProps> = ({
  files,
  problemType: _problemType,
  ...rest
}) => {
  return (
    <>
      {isEmpty(files) ? (
        <EmptyState
          title="No problematic files found"
          subtitle="Try removing any active filters"
          h="50vh"
        />
      ) : (
        <Flex flex={1} direction="column" mt={5} {...rest}>
          <Table variant="file-browser" data-testid="problematic-files-results">
            <Thead>
              <Tr>
                <Th colSpan={4}>Name</Th>
                <Th>Treaty</Th>
                <Th>Created at</Th>
                <Th>Size</Th>
              </Tr>
            </Thead>
            <Tbody>
              {files?.map((file) => {
                return (
                  <Tr key={file.id} data-testid="file-row">
                    <Td colSpan={4} data-testid="file-name">
                      <Flex
                        as={Link}
                        isTruncated
                        gridGap="3"
                        alignItems="center"
                        data-file-type="file-link"
                        to={generateFileLink(file)}
                        target="_blank"
                      >
                        <Icon
                          as={getContentTypeIcon(file)}
                          fontSize="2rem"
                          color="gray.500"
                        />
                        <Text>{file.name}</Text>
                      </Flex>
                    </Td>
                    <Td data-testid="file-status">
                      <Badge>{file.cedant}</Badge>
                    </Td>
                    <Td data-testid="file-created-at">
                      {file.createdAt ? (
                        format(file.createdAt, 'MMM DD, YYYY HH:mm A')
                      ) : (
                        <span>--</span>
                      )}
                    </Td>
                    <Td data-testid="file-size">{formatFileSize(file.size)}</Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </Flex>
      )}
    </>
  );
};
